// extracted by mini-css-extract-plugin
export default {"mutipleImageContainer":"MultipleImages_mutipleImageContainer__f771F","image":"MultipleImages_image__HjD9S"};